<!-- #3 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500; font-size: 14px"
      >
        List of Pick & Collect Location
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="pudoList"
      :loading="loader"
      :search="search"
      :server-items-length="total"
      class="elevation-1 custom-icon-size"
      :options.sync="options"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:[`item.created_at`]="{ item }">
        {{ item.created_at | localMoment | moment("DD MMM, YYYY hh:mm A") }}
        <br />({{ item.created_by_name }})
      </template>
      <template v-slot:[`item.updated_at`]="{ item }">
        {{ item.updated_at | localMoment | moment("DD MMM, YYYY hh:mm A") }}
        <br /><span v-if="item.updated_by_name"
          >({{ item.updated_by_name }})</span
        >
      </template>
      <template v-slot:top>
        <template>
          <v-form ref="form">
            <div class="custom-row p-5 pr-1">
              <v-col cols="12" sm="3" md="3" class="pb-0">
                <v-autocomplete
                  v-model="carrier_id"
                  label="Select Carrier"
                  class="pt-0 pb-0"
                  item-text="name"
                  item-value="id"
                  :items="activeCarriersListTypes"
                  outlined
                  @focus="fetchCarriers()"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-autocomplete
                  v-model="country_id"
                  :items="countries"
                  label="Select Country"
                  placeholder="Start typing to Search"
                  item-text="name"
                  item-value="id"
                  outlined
                  small-chips
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-text-field
                  v-model="city_id"
                  outlined
                  label="Select City"
                  :rules="[
                    (v) =>
                      !v ||
                      /^[^,]+$/.test(v.trim()) ||
                      'Only one city is accepted.',
                  ]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3" class="pb-0">
                <v-text-field
                  v-model="pudo_code"
                  label="Pudo Code"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3" class="pb-0">
                <v-text-field
                  v-model="zipcode"
                  label="Zip Code"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-autocomplete
                  v-model="is_locker"
                  :items="lockers"
                  outlined
                  label="Locker"
                  item-text="text"
                  item-value="value"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6">
                <v-btn
                  color="white"
                  @click="clearAll"
                  style="float: right"
                  class=""
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success mr-5"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
              </v-col>
            </div>
          </v-form>
          <v-divider class="mb-2"></v-divider>
        </template>
      </template>

      <template v-slot:item.city_id_id="{ item }">
        {{ capitalizeFirstLetter(item.city_id_id) }}
      </template>
      <template v-slot:item.name="{ item }">
        {{ item.name }}
      </template>
      <template v-slot:item.status="{ item }">
        <span :class="item.status == 1 ? 'badge-active' : 'badge'">
          {{ item.status == 1 ? "Active" : "In-active" }}
        </span>
      </template>
      <template v-slot:item.is_locker="{ item }">
        {{ item.is_locker == 1 ? "Yes" : "No" }}
      </template>
    </v-data-table>
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
export default {
  components: {},
  computed: {},
  data: () => ({
    options: {},
    from_events: [],
    carrier_id: null,
    is_locker: null,
    zip_code: null,
    city_id: null,
    pudo_code: null,
    country_id: null,
    activeCarriersListTypes: [],
    zipcode: null,
    headers: [
      {
        text: "Agency Name",
        value: "name",
        class: "body-1 font-weight-bold",
        width: "150px",
        sortable: false,
      },
      {
        text: "Pudo Code",
        value: "pudo_id",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Carrier",
        value: "carrier_name",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Country",
        value: "country_id_id",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "City",
        value: "city_id_id",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Zip Code",
        value: "postcode",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Address",
        value: "address",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Latitude",
        value: "latitude",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Locker",
        value: "is_locker",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Status",
        value: "status",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],
    pudoList: [],
    editedIndex: -1,
    loader: false,
    statusLoader: false,
    carrierId: null,
    active: "",
    name: "",
    filtersArr: {},
    carrierForm: false,
    carrierDetail: {},
    saveLoader: false,
    addList: {},
    total: 0,
    countries: [],
    cityLoader: false,
    cities: [],
    lockers: [
      {
        text: "Yes",
        value: 1,
      },
      {
        text: "No",
        value: 0,
      },
    ],
  }),

  async created() {
    this.getAddCarrierList();
    await this.fetchCarriers();
    this.getCountryList();
  },
  watch: {
    options: {
      handler() {
        this.fetchPudo();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "getPudo",
      "snackBar",
      "getAddCarrier",
      "getCarriersDropdown",
      "getCountries",
      "fetchCityList",
    ]),
    fetchCity() {
      this.cities = [];
      this.country_code = this.countries.find(
        (e) => e.id == this.country_id
      ).code;
      this.cityLoader = true;
      this.fetchCityList(this.country_code).then((res) => {
        this.cities = res.data;
        this.cityLoader = false;
      });
    },
    getCountryList() {
      this.getCountries().then((res) => {
        this.countries = res.data;
      });
    },
    async fetchCarriers() {
      if (this.activeCarriersListTypes.length) return;
      await this.getCarriersDropdown({
        pagination: 0,
        active: "all",
      })
        .then((res) => {
          this.activeCarriersListTypes = res.data;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getAddCarrierList() {
      this.getAddCarrier().then((res) => {
        this.addList = res.data;
        this.ServiceTypes();
      });
    },
    fetchPudo() {
      this.loader = true;
      this.getPudo({
        ...this.filtersArr,
        ...this.options,
      })
        .then((res) => {
          this.loader = false;
          this.pudoList = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },

    clearInput(val) {
      if (val !== "") {
        val = "";
      }
    },
    clearAll() {
      this.carrier_id = null;
      this.is_locker = null;
      this.zipcode = null;
      this.city_id = null;
      this.pudo_code = null;
      this.country_id = null;
      this.searchAll();
    },
    allFilters() {
      this.orderLoader = true;
      let obj = {
        carrier_id: this.carrier_id,
        country_id: this.country_id,
        city_id: this.city_id,
        pudo_code: this.pudo_code ? this.pudo_code.trim() : this.pudo_code,
        zipcode: this.zipcode ? this.zipcode.trim() : this.zipcode,
        is_locker: this.is_locker,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.loader = true;
      this.options.page = 1;
      this.allFilters();
      this.fetchPudo();
    },
  },
};
</script>
<style>
.carrier-logo {
  max-width: 100px;
  height: 25px;
}
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 20px 5px 5px !important;
}
.badge {
  display: inline-block;
  padding: 4px 10px;
  background-color: rgb(242, 126, 126);
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
.badge-active {
  display: inline-block;
  padding: 4px 10px;
  background-color: green;
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
</style>
